/**
 * Build-Version: VITE_APP_VERSION (von Docker BUILD_VERSION) oder Vite-define oder Fallback.
 */
// eslint-disable-next-line no-undef
const fromEnv = (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_APP_VERSION || '').trim())
export const APP_VERSION = fromEnv || (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null) || 'dev'
